import { constants as t } from "starknet";
const S = (n) => n === t.StarknetChainId.SN_MAIN ? t.StarknetChainId.SN_MAIN : t.StarknetChainId.SN_SEPOLIA;
export {
  S as g
};
